import DeviceManager from '../utils/device-manager';
import { uniqid } from '../utils/utils';
import { smoothScroll } from './smooth-scroll';

export default function initAccordeons() {
    document.querySelectorAll<HTMLElement>('[data-accordeon]').forEach($container => {
        new Accordeon($container);
    });
}

/**
 * @property {HTMLElement}   $container The accordeon container
 * @property {boolean}       autoScroll Scroll to the accordeon when toggle him
 * @property {HTMLElement[]} $tabs      Tabs into the accordeon
 */
class Accordeon {
    $container: HTMLElement;
    autoScroll: boolean = true;
    $tabs: HTMLElement[] = [];

    constructor($container: HTMLElement) {
        this.$container = $container;

        if (this.$container.dataset.accordeonAutoScroll === 'false') {
            this.autoScroll = false;
        }

        const isLocked = null !== this.$container.getAttribute('data-accordeon-locked');
        this.$tabs = Array.from(this.$container.querySelectorAll('[data-accordeon-tab]'));

        this.$tabs.forEach($tab => {
            const $tabContent = $tab.querySelector('[data-accordeon-tab-content]') as HTMLElement;
            const isActive = null === $tab.getAttribute('data-accordeon-active') ? false : true;

            let $tabCheck = $tab.querySelector<HTMLInputElement>('[data-accordeon-tab-check]');
            if (!$tabCheck) {
                const tabId = uniqid('accordeon-tab-');

                const label = $tab.dataset.accordeonTabLabel;
                if (label) {
                    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11"><g fill-rule="nonzero"><path d="M7 94.75L0 87.75 1.75 86 8.75 93 15.75 86 17.5 87.75 8.75 96.5z" transform="translate(0 -86)"/></g></svg>';

                    const $tabLabel = document.createElement('label');
                    $tabLabel.setAttribute('for', tabId);
                    $tabLabel.innerHTML = `<div><strong class="title">${label}</strong></div>` + (!isLocked ? `<span class="arrow-icon">${arrowSvg}</span>` : '');

                    if (isLocked) {
                        $tabLabel.classList.add('locked');
                    }

                    $tab.prepend($tabLabel);
                }

                if (!isLocked) {
                    $tabCheck = document.createElement('input');
                    $tabCheck.setAttribute('type', 'checkbox');
                    $tabCheck.setAttribute('data-accordeon-tab-check', '');
                    $tabCheck.setAttribute('id', tabId);
                    $tabCheck.toggleAttribute('checked', !isActive);

                    $tab.prepend($tabCheck);
                }
            }

            DeviceManager.addWindowCallback((attr, $content) => {
                const $tabContentContainer = $content.closest('.js-tab-content');
                let tabContentContainerActive = false;
                if ($tabContentContainer) {
                    tabContentContainerActive = $tabContentContainer.classList.contains('tab-active');
                    $tabContentContainer.classList.add('tab-active');
                }

                $content.style = 'transition: none; max-height: none !important;';
                const contentMaxHeight = $content.clientHeight + 50;
                $content.style = 'transition: none; max-height:' + contentMaxHeight + 'px;';

                setTimeout(() => {
                    $content.style = 'max-height:' + contentMaxHeight + 'px';
                }, 1);

                if ($tabContentContainer && !tabContentContainerActive) {
                    $tabContentContainer.classList.remove('tab-active');
                }
            }, $tabContent);

            $tabCheck?.addEventListener('change', () => {
                this.$tabs.filter($t => $t !== $tab).forEach($t => {
                    const $check = $t.querySelector('[data-accordeon-tab-check]') as HTMLInputElement;

                    if ($check) {
                        $check.setAttribute('checked', 'checked');
                    }
                });

                if (this.autoScroll) {
                    setTimeout(() => {
                        smoothScroll($tab, true);
                    }, 300);
                }
            });
        });
    }
}
